import React from "react";
import { BRAND } from "@/lib/constants";

export const Brand = ({ className = "", showTagline = false, size = "md" }) => {
  const dim = size === "sm" ? "h-9 w-9" : size === "lg" ? "h-14 w-14" : "h-11 w-11";
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <img
        src={BRAND.logo}
        alt={BRAND.name}
        className={`${dim} rounded-md object-cover ring-1 ring-[#232f25]`}
      />
      <div className="leading-none">
        <div className="font-display font-black tracking-tight text-white uppercase text-base sm:text-lg">
          E Ride <span className="text-[#8CE63C]">Power Sports</span>
        </div>
        {showTagline && (
          <div className="font-mono text-[9px] sm:text-[10px] tracking-[0.2em] text-[#69776b] uppercase mt-1">
            {BRAND.tagline}
          </div>
        )}
      </div>
    </div>
  );
};
